<template>
  <div class="block-wizard">
    <div class="block-wizard__main field">
      <h1>{{ $t('survey.title') }}</h1>
      <error-boundary v-show="errorAlert" v-on:alert-error-closed="errorAlert = false, errorMessage=''" v-bind:errorMessage="errorMessage" style="margin-top: 1em;"></error-boundary>
      <SurveyFormComponent
        @completed="completed"
        @canceled="onCancel"
        @error="onError"
        @clearError="onClearError"
        :requesting="requesting" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import SurveyFormComponent from '@/components/SurveyForm.vue';
import ErrorBoundary from '@/components/ErrorBoundary.vue';
import errorBoundary from '@/mixins/errorBoundary';
import { createYEnterpriseSectorUsers, garnishYEnterpriseSectorUsers } from '@/providers/yEnterpriseSectorUsers';

/* eslint-disable no-console */
export default {
  name: 'StartASurvey',
  mixins: [errorBoundary],
  components: {
    SurveyFormComponent,
    ErrorBoundary,
  },
  data() {
    return {
      requesting: false,
    };
  },
  methods: {
    async completed(formData) {
      // Debounce
      if (this.requesting) {
        return;
      }

      this.requesting = true;
      let creationResult;
      try {
        creationResult = await createYEnterpriseSectorUsers(formData);
      } catch (err) {
        this.onError('unknownError');
      }

      // Récupération d'un accès à Ethnos
      if (creationResult && this.$route.name === 'StartASurvey') {
        try {
          const { data } = await garnishYEnterpriseSectorUsers({
            Namespace: creationResult.data.Namespace,
            EnterpriseNumber: creationResult.data.EnterpriseNumber,
            SectorCode: creationResult.data.SectorCode,
            id: creationResult.data.surveySessionId,
          });
          if (_.get(data, 'EthnosURL')) {
            window.location.href = `${_.get(data, 'EthnosURL')}&${process.env.VUE_APP_ETHNOS_CALLBACK_KEY}=${window.location.host}/survey/BaaS22E`;
          }
        } catch (err) {
          this.requesting = false;
          this.displayError('retrieveEthnosSurveySession');
        }
      } else {
        this.$router.push('/survey');
      }
    },
    onError(error) {
      this.displayError(error);
    },
    onClearError() {
      this.clearError();
    },
    onCancel() {
      this.$router.push('/survey');
    },
  },
};
</script>

<style>
.block-wizard__main .content h6{
  color: #2368a1;
  font-weight: 700;
  margin-top: 32px;
  font-size: 1.1em;
}
.field label {
  margin-right: 40px;
}
</style>
